import { render } from "./RateItem.vue?vue&type=template&id=0db9dba3&scoped=true"
import script from "./RateItem.vue?vue&type=script&lang=js"
export * from "./RateItem.vue?vue&type=script&lang=js"

import "./RateItem.vue?vue&type=style&index=0&id=0db9dba3&scoped=true&lang=scss"
import "./RateItem.vue?vue&type=style&index=1&id=0db9dba3&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db9dba3"]])

export default __exports__